import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';

export function useSiteImages() {
  const [siteImages, setSiteImages] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getSiteImages()
      .then((data) => {
        if (active) {
          const map: Record<string, string> = {};
          data.forEach((item) => {
            map[item.key] = item.imageUrl;
          });
          setSiteImages(map);
        }
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar imagens do site'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { siteImages, isLoading, error };
}
